import Popup from "reactjs-popup";
import {Trans, useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";


function TimeOutModal() {
    const { i18n } = useTranslation();
    let history = useNavigate();
    const [popupOpen, setPopupOpen] = useState(false);
    const [dataCleared, setDataCleared] = useState(false);
    const [longSession, setLongSession] = useState(false)
    const [first, setFirst] = useState(true)

    const longerSession = () => {
        let date = new Date(Date.now() + 2 * (60 * 60 * 1000) );
        localStorage.setItem('t', date);
        setLongSession(true)
        setFirst(false)
    }

    const closeModal = () => {
        setPopupOpen(false)
    }

    const clearData = () => {
        localStorage.clear()
        setDataCleared(true)
        setFirst(false)
        history("/"+i18n.language)
    }

    useEffect(()=>{
        let date = new Date()
        //console.log('Now '+ date);
        //localStorage.setItem('t', new Date(new Date().setTime(new Date().getTime() + 12 * 60 * 1000)));
        let sessionEnd = !!localStorage.getItem('t') && new Date(localStorage.getItem('t'));
        let sessionAboutToEnd = !!localStorage.getItem('t') && new Date(new Date().setTime(sessionEnd.getTime() - 45 * 60 * 1000));

            //console.log('End '+ sessionEnd)
            //console.log('About '+ sessionAboutToEnd)
        if (date  > sessionAboutToEnd && date  < sessionEnd) {
            setPopupOpen(true)
            //console.log('About '+ sessionAboutToEnd)
        }
        if (!!sessionEnd && date  > sessionEnd) {
            //console.log('End '+ sessionEnd)
            clearData()
        }

    },[]);



        return (
            <div>
            {popupOpen &&
            <Popup
                open={popupOpen}
                closeOnDocumentClick
                onClose={closeModal}>

                <div className={
                    "modal-content"
                }>
                    <div className={"modal-header"}>
                        <a className="close" onClick={closeModal}>
                            &times;
                        </a>
                    </div>

                    {first &&
                    <div className="modal-body">
                        <Trans i18nKey={"Votre session va être expirée et toutes les données encodées vont être effacées. Voulez-vous la prolonger?"}>
                        <p>Votre session va être expirée et toutes les données encodées vont être effacées. Voulez-vous la prolonger?</p>
                        </Trans>
                    </div>
                    }
                    {first &&
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary danger small" onClick={clearData}>{i18n.t('Non')}</button>
                        <button onClick={longerSession}
                                className="btn btn-primary success small">{i18n.t('Oui')}</button>
                    </div>
                    }
                    {!first && !!dataCleared &&
                    <div className="modal-body">
                        <Trans i18nKey={"Les données ont été effacées"}>
                            <p>Les données de vos formulaires sont effacées.</p>
                        </Trans>
                    </div>

                    }
                    {!first && !!longSession &&
                    <div className="modal-body">
                        {i18n.t("Votre session a été prolongée")}
                    </div>

                    }

                </div>
            </Popup>
    }
            </div>)
}
export default TimeOutModal;
